/* ==========================================================================
   EXHIALAMBRE IMPORTACIONES — Theme JS
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------- Mobile nav ---------------- */
  var navToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      var expanded = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!expanded));
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.querySelector('[data-cart-overlay]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openCartDrawer();
    }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) {
      closeCartDrawer();
    }
  });

  function renderCartDrawer(cart) {
    var itemsWrap = document.querySelector('[data-cart-drawer-items]');
    var footerWrap = document.querySelector('[data-cart-drawer-footer]');
    var countEls = document.querySelectorAll('[data-cart-count]');

    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (!itemsWrap) return;

    if (cart.item_count === 0) {
      itemsWrap.innerHTML = '<div class="empty-state"><p>Tu carrito está vacío.</p></div>';
      if (footerWrap) footerWrap.innerHTML = '';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      html += '' +
        '<div class="cart-item" data-cart-line="' + item.key + '">' +
          '<img class="cart-item__image" src="' + (item.image || '') + '" alt="' + item.product_title + '" width="100" height="100" loading="lazy">' +
          '<div style="flex:1">' +
            '<div class="cart-item__title">' + item.product_title + '</div>' +
            (item.variant_title ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '') +
            '<div class="quantity-selector" data-qty-selector>' +
              '<button type="button" data-qty-decrease>&minus;</button>' +
              '<input type="number" min="0" value="' + item.quantity + '" data-qty-input data-line-key="' + item.key + '">' +
              '<button type="button" data-qty-increase>+</button>' +
            '</div>' +
            '<button class="cart-item__remove" data-cart-remove data-line-key="' + item.key + '">Eliminar</button>' +
          '</div>' +
          '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
    });
    itemsWrap.innerHTML = html;

    if (footerWrap) {
      footerWrap.innerHTML = '' +
        '<div class="cart-summary__row cart-summary__total"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
        '<a href="/cart" class="btn btn--outline btn--full" style="margin-top:14px;">Ver carrito</a>' +
        '<a href="/checkout" class="btn btn--full" style="margin-top:10px;">Finalizar compra</a>';
    }
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount.replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  function fetchCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCartDrawer);
  }

  // Add to cart (forms with data-add-to-cart-form)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-to-cart-form]');
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Agregando...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.fromEntries(new FormData(form)))
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        fetchCart();
        openCartDrawer();
      })
      .catch(function () {
        alert('No se pudo agregar el producto. Intenta nuevamente.');
      })
      .finally(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
      });
  });

  // Quantity + / - inside cart drawer & cart page
  document.addEventListener('click', function (e) {
    var decrease = e.target.closest('[data-qty-decrease]');
    var increase = e.target.closest('[data-qty-increase]');
    if (decrease || increase) {
      var wrap = e.target.closest('[data-qty-selector]');
      var input = wrap.querySelector('[data-qty-input]');
      var val = parseInt(input.value, 10) || 1;
      val = increase ? val + 1 : Math.max(0, val - 1);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      updateLine(removeBtn.getAttribute('data-line-key'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var qtyInput = e.target.closest('[data-qty-input]');
    if (qtyInput) {
      updateLine(qtyInput.getAttribute('data-line-key'), parseInt(qtyInput.value, 10) || 0);
    }
  });

  function updateLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        if (document.querySelector('[data-cart-page]')) {
          window.location.reload();
        }
      });
  }

  // Init cart count on load
  document.addEventListener('DOMContentLoaded', fetchCart);

  /* ---------------- Category filters (collection grid) ---------------- */
  document.addEventListener('click', function (e) {
    var filterBtn = e.target.closest('[data-filter-btn]');
    if (!filterBtn) return;
    var group = filterBtn.closest('[data-filter-group]');
    group.querySelectorAll('[data-filter-btn]').forEach(function (b) { b.classList.remove('is-active'); });
    filterBtn.classList.add('is-active');

    var filterValue = filterBtn.getAttribute('data-filter-btn');
    var grid = document.querySelector('[data-product-grid]');
    if (!grid) return;

    grid.querySelectorAll('[data-product-tags]').forEach(function (card) {
      var tags = (card.getAttribute('data-product-tags') || '').toLowerCase();
      var show = filterValue === 'all' || tags.indexOf(filterValue) !== -1;
      card.style.display = show ? '' : 'none';
    });

    var visibleCount = grid.querySelectorAll('[data-product-tags]:not([style*="display: none"])').length;
    var emptyState = document.querySelector('[data-filter-empty]');
    if (emptyState) emptyState.style.display = visibleCount === 0 ? 'block' : 'none';
  });

  /* ---------------- Product gallery thumbnails ---------------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-product-gallery]');
    var mainImg = gallery.querySelector('[data-gallery-main-img]');
    mainImg.src = thumb.getAttribute('data-full-src');
    mainImg.alt = thumb.getAttribute('data-alt') || '';
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---------------- Product quantity selector (product page) ---------------- */
  document.addEventListener('click', function (e) {
    var decrease = e.target.closest('[data-product-qty-decrease]');
    var increase = e.target.closest('[data-product-qty-increase]');
    if (!decrease && !increase) return;
    var wrap = e.target.closest('[data-product-qty-selector]');
    var input = wrap.querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    input.value = increase ? val + 1 : Math.max(1, val - 1);
  });

  /* ---------------- Variant price / image swap on product page ---------------- */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-variant-select]');
    if (!select) return;
    var form = select.closest('[data-add-to-cart-form]');
    var selectedOption = select.options[select.selectedIndex];
    var price = selectedOption.getAttribute('data-price');
    var available = selectedOption.getAttribute('data-available') === 'true';
    var variantId = selectedOption.value;

    var priceEl = document.querySelector('[data-product-price]');
    if (priceEl && price) priceEl.textContent = formatMoney(parseInt(price, 10));

    var hiddenInput = form.querySelector('input[name="id"]');
    if (hiddenInput) hiddenInput.value = variantId;

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = !available;
      submitBtn.textContent = available ? submitBtn.getAttribute('data-label-available') : 'Agotado';
    }
  });

})();
